"use client"

import Text from "@/components/common/Typography/Text"
import Title from "@/components/common/Typography/Title"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import { useTERouter } from "@/hooks/app/useTERouter"
import { TypeTourSearchItem } from "@/lib/redux/features/tour/types"
import { Button, Col, Row } from "antd"
import { CSSProperties, FC, useState } from "react"
import { useTranslation } from "react-i18next"

type ListCategoriesProps = {
  tourCategories: TypeTourSearchItem[],
  onChange?: () => void
}

const ListCategories: FC<ListCategoriesProps> = ({ tourCategories, onChange }) => {
  const router = useTERouter()
  const [countShown, setCountShown] = useState(5)
  const { t } = useTranslation()

  const onClickTour = (tour: TypeTourSearchItem) => {
    router.push(`/tours/category/${tour.id}`)
    onChange && onChange()
  }

  return (
    <>
      {/* {renderTitle(title.text, title.style)} */}
      {tourCategories
        .slice(0, countShown)
        .map((tour) => {
          return (
            <Row style={{ marginTop: 10 }} className="flights__list--filter-input--box" justify='space-between' align='middle'>
              <Col span={24}>
                <Button
                  style={{ justifyContent: 'start', height: 'auto', maxHeight: 'unset', whiteSpace: 'wrap', textAlign: 'start' }}
                  type='text'
                  block
                  onClick={() => onClickTour(tour)}
                >
                  <Text>
                    {tour.name}
                  </Text>
                </Button>
              </Col>
            </Row>
          )
        })}
      {tourCategories.length > 5 && (
        <Row justify='end'>
          <Button
            type='link'
            onClick={() => setCountShown(countShown >= tourCategories.length ? 5 : tourCategories.length)}
          >
            {countShown >= tourCategories.length ? t("common.see_less") : t("common.see_all")}
          </Button>
        </Row>
      )}
    </>
  )
}

export default ListCategories